import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.search.ai');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

type SearchRightType = 'patentUtility' | 'trademark' | 'design';

interface ClassOption {
    label: string;
    value: string;
}

interface AiSearchForm {
    rightType: SearchRightType;
    keywordInput: string;
    keywords: string[];
    technologyDescription: string;
    trademarkName: string;
    goodsName: string;
    trademarkClasses: string[];
    designClasses: string[];
    applicationDateFrom: string;
}

interface SearchResult {
    id: string;
    rightType: string;
    registrationNumber: string;
    title: string;
    applicant: string;
    status: string;
    summary: string;
    matchRate: number;
    aiReason?: string;
    requested?: boolean;
    receiptNo?: string;
}

interface CandidateConsultForm {
    requesterName: string;
    company: string;
    contact: string;
    email: string;
    request: string;
    privacyAgreed: boolean;
}

@Component({
    selector: 'wiz-page-search-ai',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.search.ai/view.scss */
:host {
  display: block;
  min-height: 100%;
}`],
})
export class PageSearchAiComponent implements OnInit {
    public searched: boolean = false;
    public searching: boolean = false;
    public results: SearchResult[] = [];
    public resultMessage: string = '';
    public aiKeywords: string[] = [];
    public aiMessage: string = '';
    public aiFiltered: boolean = false;
    public searchProgress: number = 0;
    public searchStepText: string = '';
    public resultPage: number = 1;
    public readonly resultPageSize: number = 4;
    public form: AiSearchForm = this.createForm();
    public candidateConsultModalOpen: boolean = false;
    public candidateConsultSubmitting: boolean = false;
    public selectedCandidate: SearchResult | null = null;
    public candidateConsultForm: CandidateConsultForm = this.createCandidateConsultForm();
    private keywordComposing: boolean = false;
    private keywordEnterQueued: boolean = false;
    private searchProgressTimer: number | null = null;
    public rightTypes: Array<{ label: string; value: SearchRightType; description: string }> = [
        { label: '특허/실용', value: 'patentUtility', description: '기술 키워드와 기술내용 기준' },
        { label: '상표', value: 'trademark', description: '상표명과 상품류 기준' },
        { label: '디자인', value: 'design', description: '물품명과 물품류 기준' }
    ];
    public trademarkClasses: ClassOption[] = [
        { label: '1류 - 화학제·수지·비료 등', value: '1류' },
        { label: '2류 - 페인트·염료 등', value: '2류' },
        { label: '3류 - 화장품·세정제 등', value: '3류' },
        { label: '4류 - 공업용 유지·연료 등', value: '4류' },
        { label: '5류 - 의약품·위생용품 등', value: '5류' },
        { label: '6류 - 금속재료·금속제품 등', value: '6류' },
        { label: '7류 - 기계·공작기계 등', value: '7류' },
        { label: '8류 - 수공구·식기류 등', value: '8류' },
        { label: '9류 - 과학·전기·소프트웨어 등', value: '9류' },
        { label: '10류 - 의료기기·보조기구 등', value: '10류' },
        { label: '11류 - 조명·냉난방·위생설비 등', value: '11류' },
        { label: '12류 - 운송수단·부품 등', value: '12류' },
        { label: '13류 - 화기·폭죽 등', value: '13류' },
        { label: '14류 - 귀금속·시계 등', value: '14류' },
        { label: '15류 - 악기 등', value: '15류' },
        { label: '16류 - 종이·인쇄물 등', value: '16류' },
        { label: '17류 - 고무·플라스틱 재료 등', value: '17류' },
        { label: '18류 - 가죽·가방 등', value: '18류' },
        { label: '19류 - 비금속 건축재료 등', value: '19류' },
        { label: '20류 - 가구·비금속 용기 등', value: '20류' },
        { label: '21류 - 가정·주방용품 등', value: '21류' },
        { label: '22류 - 로프·텐트·섬유원료 등', value: '22류' },
        { label: '23류 - 방적사·실 등', value: '23류' },
        { label: '24류 - 직물·침구 등', value: '24류' },
        { label: '25류 - 의류·신발·모자 등', value: '25류' },
        { label: '26류 - 레이스·단추·장식품 등', value: '26류' },
        { label: '27류 - 카펫·벽지 등', value: '27류' },
        { label: '28류 - 게임·완구·운동용품 등', value: '28류' },
        { label: '29류 - 육류·가공식품 등', value: '29류' },
        { label: '30류 - 커피·차·과자 등', value: '30류' },
        { label: '31류 - 농산물·신선식품 등', value: '31류' },
        { label: '32류 - 맥주·비알코올음료 등', value: '32류' },
        { label: '33류 - 주류 등', value: '33류' },
        { label: '34류 - 담배·흡연용품 등', value: '34류' },
        { label: '35류 - 광고·사업관리 등', value: '35류' },
        { label: '36류 - 보험·금융·부동산 등', value: '36류' },
        { label: '37류 - 건설·수리업 등', value: '37류' },
        { label: '38류 - 통신업 등', value: '38류' },
        { label: '39류 - 운송·보관·여행업 등', value: '39류' },
        { label: '40류 - 재료처리업 등', value: '40류' },
        { label: '41류 - 교육·엔터테인먼트 등', value: '41류' },
        { label: '42류 - 과학·기술·디자인 등', value: '42류' },
        { label: '43류 - 음식·숙박업 등', value: '43류' },
        { label: '44류 - 의료·헬스·조경업 등', value: '44류' },
        { label: '45류 - 법률·경비·장의업 등', value: '45류' }
    ];
    public designClasses: ClassOption[] = [
        { label: '1류 - 식품', value: '1류' },
        { label: '2류 - 의류 및 패션잡화용품', value: '2류' },
        { label: '3류 - 여행용품·케이스·개인용품', value: '3류' },
        { label: '4류 - 브러시류', value: '4류' },
        { label: '5류 - 섬유제품·인조천연 시트', value: '5류' },
        { label: '6류 - 가구 및 침구류', value: '6류' },
        { label: '7류 - 가정용품·주방용품', value: '7류' },
        { label: '8류 - 공구·철물류', value: '8류' },
        { label: '9류 - 포장용기·운반용기', value: '9류' },
        { label: '10류 - 시계·측정기기', value: '10류' },
        { label: '11류 - 장식용품', value: '11류' },
        { label: '12류 - 운송·승강수단', value: '12류' },
        { label: '13류 - 전기 발생·분배·변환기기', value: '13류' },
        { label: '14류 - 기록·통신·정보검색기기', value: '14류' },
        { label: '15류 - 기타 기계류', value: '15류' },
        { label: '16류 - 사진·영상·광학기기', value: '16류' },
        { label: '17류 - 악기', value: '17류' },
        { label: '18류 - 인쇄·사무용 기계', value: '18류' },
        { label: '19류 - 문방구·사무용품·교재', value: '19류' },
        { label: '20류 - 판매·광고용품·표지판', value: '20류' },
        { label: '21류 - 게임·완구·스포츠용품', value: '21류' },
        { label: '22류 - 무기·화약·사냥·낚시용품', value: '22류' },
        { label: '23류 - 유체공급·위생·난방·환기기기', value: '23류' },
        { label: '24류 - 의료·실험실용 기기', value: '24류' },
        { label: '25류 - 건축 유닛·건설자재', value: '25류' },
        { label: '26류 - 조명기기', value: '26류' },
        { label: '27류 - 담배 및 흡연용품', value: '27류' },
        { label: '28류 - 의약품·화장품·위생용품', value: '28류' },
        { label: '29류 - 화재·위험방지·구조용품', value: '29류' },
        { label: '30류 - 동물관리 및 사육용품', value: '30류' },
        { label: '31류 - 기타 조리용 기계·기구', value: '31류' }
    ];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        if (!this.service.auth.allow('/market/cases')) return;
        await this.service.render();
    }

    public async selectRightType(type: SearchRightType) {
        this.form.rightType = type;
        this.searched = false;
        this.resultMessage = '';
        this.aiKeywords = [];
        this.aiMessage = '';
        this.aiFiltered = false;
        this.resetSearchProgress();
        this.resultPage = 1;
        this.results = [];
        await this.service.render();
    }

    public async addKeyword() {
        const value = this.form.keywordInput.trim();
        if (!value) return;

        if (this.form.keywords.length >= 5) {
            await this.service.modal.error('기술 키워드는 5개까지 입력할 수 있습니다.');
            return;
        }

        if (!this.form.keywords.includes(value)) {
            this.form.keywords = [...this.form.keywords, value];
        }

        this.form.keywordInput = '';
        await this.service.render();
    }

    public onKeywordCompositionStart() {
        this.keywordComposing = true;
        this.keywordEnterQueued = false;
    }

    public onKeywordCompositionEnd() {
        this.keywordComposing = false;
        if (!this.keywordEnterQueued) return;

        this.keywordEnterQueued = false;
        window.setTimeout(() => {
            void this.addKeyword();
        }, 0);
    }

    public async addKeywordByEnter(event: KeyboardEvent) {
        event.preventDefault();
        if (event.isComposing || this.keywordComposing || event.keyCode === 229) {
            this.keywordEnterQueued = true;
            return;
        }

        await this.addKeyword();
    }

    public async removeKeyword(keyword: string) {
        this.form.keywords = this.form.keywords.filter((item) => item !== keyword);
        await this.service.render();
    }

    public isTrademarkClassSelected(classValue: string) {
        return this.form.trademarkClasses.includes(classValue);
    }

    public async toggleTrademarkClass(classValue: string) {
        this.form.trademarkClasses = this.toggleListItem(this.form.trademarkClasses, classValue);
        await this.service.render();
    }

    public isDesignClassSelected(classValue: string) {
        return this.form.designClasses.includes(classValue);
    }

    public async toggleDesignClass(classValue: string) {
        this.form.designClasses = this.toggleListItem(this.form.designClasses, classValue);
        await this.service.render();
    }

    public async runSearch() {
        if (!(await this.validateSearch())) return;

        this.searching = true;
        this.searched = false;
        this.resultMessage = '';
        this.aiKeywords = [];
        this.aiMessage = '';
        this.aiFiltered = false;
        this.startSearchProgress();
        this.resultPage = 1;
        this.results = [];
        await this.service.render();

        const payload = this.searchPayload();
        const { code, data } = await wiz.call('search', payload);

        this.searching = false;

        if (code !== 200) {
            this.resetSearchProgress();
            await this.service.modal.error(this.errorMessage(data, 'KIPRIS 검색에 실패했습니다.'));
            await this.service.render();
            return;
        }

        this.completeSearchProgress();
        this.results = data?.results || [];
        this.resultMessage = data?.message || '';
        this.aiKeywords = data?.aiKeywords || [];
        this.aiMessage = data?.aiMessage || '';
        this.aiFiltered = data?.aiFiltered || false;
        this.resultPage = 1;
        this.searched = true;
        await this.service.render();
    }

    public progressWidth() {
        return `${this.searchProgress}%`;
    }

    public async requestResearch(result: SearchResult) {
        if (result.requested) return;
        this.selectedCandidate = result;
        this.candidateConsultForm = this.createCandidateConsultForm();
        this.candidateConsultModalOpen = true;
        await this.service.render();
    }

    public async closeCandidateConsult() {
        this.candidateConsultModalOpen = false;
        this.selectedCandidate = null;
        this.candidateConsultForm = this.createCandidateConsultForm();
        this.candidateConsultSubmitting = false;
        await this.service.render();
    }

    public async toggleCandidatePrivacyAgreement() {
        this.candidateConsultForm.privacyAgreed = !this.candidateConsultForm.privacyAgreed;
        await this.service.render();
    }

    public async submitCandidateConsult() {
        const candidate = this.selectedCandidate;
        const form = this.candidateConsultForm;
        if (!candidate || !form.requesterName.trim() || !form.contact.trim() || !form.email.trim() || !form.request.trim()) {
            await this.service.modal.error('신청자 정보와 상담 요청사항을 입력해주세요.');
            return;
        }
        if (!/^\S+@\S+\.\S+$/.test(form.email.trim()) || form.contact.replace(/\D/g, '').length < 9) {
            await this.service.modal.error('연락처와 이메일 형식을 확인해주세요.');
            return;
        }
        if (!form.privacyAgreed) {
            await this.service.modal.error('개인정보 수집 및 이용 동의가 필요합니다.');
            return;
        }

        this.candidateConsultSubmitting = true;
        await this.service.render();
        const { code, data } = await wiz.call('submit_consultation', {
            payload: JSON.stringify({
                flow: 'ai_candidate_consultation',
                data: {
                    requester: { name: form.requesterName.trim(), company: form.company.trim() },
                    contact: { phone: form.contact.trim(), email: form.email.trim() },
                    privacyAgreed: form.privacyAgreed,
                    feeAgreed: false,
                    details: {
                        candidateId: candidate.id,
                        rightTitle: candidate.title,
                        registrationNumber: candidate.registrationNumber,
                        rightType: candidate.rightType,
                        applicant: candidate.applicant,
                        status: candidate.status,
                        summary: candidate.summary,
                        matchRate: candidate.matchRate,
                        aiReason: candidate.aiReason || '',
                        searchCriteria: this.searchPayload(),
                        request: form.request.trim()
                    }
                }
            })
        });
        this.candidateConsultSubmitting = false;
        if (code !== 200) {
            await this.service.modal.error(this.consultationError(data));
            await this.service.render();
            return;
        }

        candidate.requested = true;
        candidate.receiptNo = data.receiptNo;
        this.candidateConsultModalOpen = false;
        this.selectedCandidate = null;
        this.candidateConsultForm = this.createCandidateConsultForm();
        await this.service.modal.success(`선택한 등록권리 상담이 접수되었습니다. 접수번호: ${candidate.receiptNo}`);
        await this.service.render();
    }

    public rightTypeLabel(type: SearchRightType = this.form.rightType) {
        if (type === 'patentUtility') return '특허/실용';
        if (type === 'trademark') return '상표';
        return '디자인';
    }

    public get totalPages() {
        return Math.max(1, Math.ceil(this.results.length / this.resultPageSize));
    }

    public get resultPages() {
        return Array.from({ length: this.totalPages }, (_, index) => index + 1);
    }

    public get pagedResults() {
        const start = (this.resultPage - 1) * this.resultPageSize;
        return this.results.slice(start, start + this.resultPageSize);
    }

    public get resultStart() {
        if (!this.results.length) return 0;
        return (this.resultPage - 1) * this.resultPageSize + 1;
    }

    public get resultEnd() {
        return Math.min(this.resultPage * this.resultPageSize, this.results.length);
    }

    public async setResultPage(page: number) {
        const next = Math.min(Math.max(page, 1), this.totalPages);
        if (next === this.resultPage) return;
        this.resultPage = next;
        await this.service.render();
    }

    private async validateSearch() {
        if (this.form.rightType === 'patentUtility') {
            if (!this.form.keywords.length) {
                await this.service.modal.error('기술 키워드를 1개 이상 입력해주세요.');
                return false;
            }

            if (this.form.technologyDescription.length > 300) {
                await this.service.modal.error('기술내용은 300자 이내로 입력해주세요.');
                return false;
            }

            if (!this.form.technologyDescription.trim()) {
                await this.service.modal.error('AI 판정을 위해 기술내용을 입력해주세요.');
                return false;
            }
        }

        if (this.form.rightType === 'trademark') {
            if (!this.form.trademarkName.trim()) {
                await this.service.modal.error('실제 KIPRIS 검색을 위해 상표명을 입력해주세요.');
                return false;
            }

            if (!this.form.trademarkClasses.length) {
                await this.service.modal.error('상품류를 1개 이상 선택해주세요.');
                return false;
            }
        }

        if (this.form.rightType === 'design') {
            if (!this.form.goodsName.trim()) {
                await this.service.modal.error('실제 KIPRIS 검색을 위해 물품명을 입력해주세요.');
                return false;
            }

            if (!this.form.designClasses.length) {
                await this.service.modal.error('물품류를 1개 이상 선택해주세요.');
                return false;
            }
        }

        return true;
    }

    private createForm(): AiSearchForm {
        return {
            rightType: 'patentUtility',
            keywordInput: '',
            keywords: [],
            technologyDescription: '',
            trademarkName: '',
            goodsName: '',
            trademarkClasses: [],
            designClasses: [],
            applicationDateFrom: ''
        };
    }

    private createCandidateConsultForm(): CandidateConsultForm {
        return {
            requesterName: '',
            company: '',
            contact: '',
            email: '',
            request: '',
            privacyAgreed: false
        };
    }

    private toggleListItem(list: string[], item: string) {
        if (list.includes(item)) {
            return list.filter((value) => value !== item);
        }

        return [...list, item];
    }

    private searchPayload() {
        return {
            ...JSON.parse(JSON.stringify(this.form)),
            keywords: this.form.keywords.join(','),
            trademarkClasses: this.form.trademarkClasses.join(','),
            designClasses: this.form.designClasses.join(',')
        };
    }

    private startSearchProgress() {
        this.clearSearchProgressTimer();
        this.searchProgress = 12;
        this.searchStepText = 'AI가 기술내용을 분석하고 있습니다.';
        this.searchProgressTimer = window.setInterval(() => {
            if (this.searchProgress < 35) {
                this.searchProgress += 4;
                this.searchStepText = 'AI가 검색 키워드를 확장하고 있습니다.';
                return;
            }

            if (this.searchProgress < 68) {
                this.searchProgress += 3;
                this.searchStepText = 'KIPRIS에서 등록권리 후보를 조회하고 있습니다.';
                return;
            }

            if (this.searchProgress < 90) {
                this.searchProgress += 2;
                this.searchStepText = 'AI가 후보 적합도를 판정하고 있습니다.';
            }
        }, 700);
    }

    private completeSearchProgress() {
        this.clearSearchProgressTimer();
        this.searchProgress = 100;
        this.searchStepText = '후보 정리가 완료되었습니다.';
    }

    private resetSearchProgress() {
        this.clearSearchProgressTimer();
        this.searchProgress = 0;
        this.searchStepText = '';
    }

    private clearSearchProgressTimer() {
        if (this.searchProgressTimer === null) return;
        window.clearInterval(this.searchProgressTimer);
        this.searchProgressTimer = null;
    }

    private errorMessage(data: any, fallback: string) {
        if (!data) return fallback;
        if (typeof data === 'string') return data;
        return data.message || fallback;
    }

    private consultationError(data: any) {
        const message = data?.message || '상담 접수에 실패했습니다.';
        if (data?.errorType === 'validation') return `입력값 오류: ${message}`;
        if (data?.errorType === 'network') return `네트워크 오류: ${message}`;
        return `서버 오류: ${message}`;
    }
}

export default PageSearchAiComponent;